export default __webpack_public_path__ + "static/media/plan_start.97cc68d8.png";